import { TransactionList } from "@/features/transactions";
import { S } from "@/shared/constants/styles";

export default function RecentTransactions({
  monthTxns,
  openAddTx,
  openEditTx,
  deleteTx,
  deleteTxId,
  setDeleteTxId,
  incomeList,
  getGroup,
  currency,
  theme,
  anomalyMap = new Map(),
}) {
  const recent = [...monthTxns]
    .sort((a, b) => (b.date || "").localeCompare(a.date || ""))
    .slice(0, 8);

  return (
    <div style={{ ...S.card, padding: 22 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <div style={S.sectionTitle}>Recent Transactions</div>
        <button onClick={openAddTx} style={S.btnSm()}>
          + Add
        </button>
      </div>
      <TransactionList
        transactions={recent}
        onEdit={openEditTx}
        onDelete={deleteTx}
        deleteTxId={deleteTxId}
        setDeleteTxId={setDeleteTxId}
        incomeList={incomeList}
        getGroup={getGroup}
        currency={currency}
        theme={theme}
        emptyMessage="No transactions this month"
        compact
        anomalyMap={anomalyMap}
      />
    </div>
  );
}
